// extracted by mini-css-extract-plugin
export default {"shaking_image":"ShakingHand_shaking_image__XYiMS"};